import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { importSalaryData } from '@/services/salarylb';
import { request, METHOD } from '@/utils/request';
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      salaryTotalFileList: [],
      performanceDetailFileList: []
    };
  },
  methods: {
    handleOk: function handleOk() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this.form.validateFields(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(err, values) {
                  var formData, salaryTotalFile, performanceDetailFile, rsp, response, errorDetails, msg, _t;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        if (!err) {
                          _context2.n = 1;
                          break;
                        }
                        return _context2.a(2);
                      case 1:
                        if (!(_this.salaryTotalFileList.length === 0)) {
                          _context2.n = 2;
                          break;
                        }
                        _this.$message.warning('请上传工资总表文件');
                        return _context2.a(2);
                      case 2:
                        if (!(_this.performanceDetailFileList.length === 0)) {
                          _context2.n = 3;
                          break;
                        }
                        _this.$message.warning('请上传奖励性绩效明细表文件');
                        return _context2.a(2);
                      case 3:
                        _this.confirmLoading = true;
                        _context2.p = 4;
                        // 构造提交数据
                        formData = new FormData();
                        formData.append('department', values.department);
                        formData.append('salaryMonth', values.salaryMonth);
                        formData.append('salaryTitle', values.salaryTitle);

                        // 添加文件
                        if (_this.salaryTotalFileList.length > 0) {
                          // 使用originFileObj获取原始文件对象
                          salaryTotalFile = _this.salaryTotalFileList[0].originFileObj || _this.salaryTotalFileList[0];
                          formData.append('salaryTotalFile', salaryTotalFile);
                        }
                        if (_this.performanceDetailFileList.length > 0) {
                          // 使用originFileObj获取原始文件对象
                          performanceDetailFile = _this.performanceDetailFileList[0].originFileObj || _this.performanceDetailFileList[0];
                          formData.append('performanceDetailFile', performanceDetailFile);
                        }

                        // 调用导入API
                        _context2.n = 5;
                        return importSalaryData(formData);
                      case 5:
                        rsp = _context2.v;
                        response = {
                          data: rsp
                        };
                        if (response.data.code === 200) {
                          // 检查是否包含反馈信息
                          if (response.data.hasFeedback) {
                            // 显示提示信息
                            _this.$message.warning(response.data.message || '存在无效身份证号，请下载反馈文件查看');

                            // 显示确认对话框，询问用户是否下载反馈文件
                            _this.$confirm('存在身份证号未通过有效性校验的数据，是否下载反馈文件？', '检测到无效身份证号', {
                              confirmButtonText: '下载',
                              cancelButtonText: '关闭',
                              type: 'warning'
                            }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                              return _regenerator().w(function (_context) {
                                while (1) switch (_context.n) {
                                  case 0:
                                    _context.n = 1;
                                    return _this.downloadFeedbackFile(response.data.feedbackRecords || response.data.feedbackData);
                                  case 1:
                                    // 关闭模态框
                                    _this.handleCancel();
                                    // 通知父组件刷新数据（即使有部分数据导入成功）
                                    _this.$emit('import-success');
                                  case 2:
                                    return _context.a(2);
                                }
                              }, _callee);
                            }))).catch(function () {
                              // 用户选择不下载，仍然关闭模态框，因为部分数据已成功导入
                              _this.handleCancel();
                              // 通知父组件刷新数据
                              _this.$emit('import-success');
                            });
                          } else {
                            // 导入完全成功
                            _this.$message.success(response.data.message || '导入成功');
                            _this.handleCancel();
                            // 通知父组件刷新数据
                            _this.$emit('import-success');
                          }
                        } else {
                          // 检查服务器返回的是解析错误还是其他错误
                          if (response.data && response.data.errorType === 'parse_error') {
                            // Excel解析错误 - 提取具体错误信息
                            errorDetails = response.data.errorMessage || response.data.message || '未知错误';
                            msg = response.data.message || 'Excel文件解析错误'; // 显示错误信息
                            _this.$alert("".concat(msg, "\n\n").concat(errorDetails), 'Excel文件解析错误', {
                              confirmButtonText: '确定',
                              type: 'error'
                            });
                          } else {
                            _this.$message.error(response.data.message || '导入失败');
                          }
                        }
                        _context2.n = 7;
                        break;
                      case 6:
                        _context2.p = 6;
                        _t = _context2.v;
                        debugger;
                        _this.$message.error('导入失败: ' + (_t.message || '网络错误'));
                      case 7:
                        _context2.p = 7;
                        _this.confirmLoading = false;
                        return _context2.f(7);
                      case 8:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[4, 6, 7, 8]]);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleCancel: function handleCancel() {
      this.form.resetFields();
      this.salaryTotalFileList = [];
      this.performanceDetailFileList = [];
      this.$emit('cancel');
    },
    handleSalaryTotalRemove: function handleSalaryTotalRemove() {
      this.salaryTotalFileList = [];
    },
    beforeSalaryTotalUpload: function beforeSalaryTotalUpload(file) {
      this.salaryTotalFileList = [file];
      return false; // 阻止自动上传
    },
    handlePerformanceDetailRemove: function handlePerformanceDetailRemove() {
      this.performanceDetailFileList = [];
    },
    beforePerformanceDetailUpload: function beforePerformanceDetailUpload(file) {
      this.performanceDetailFileList = [file];
      return false; // 阻止自动上传
    },
    downloadTemplate: function downloadTemplate(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var url, fileName, response, blob, downloadUrl, link, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              url = '';
              fileName = '';
              debugger;
              if (!(type === 'salary')) {
                _context4.n = 1;
                break;
              }
              url = '/api/salaryController/downloadSalaryTemplate';
              fileName = '工资总表模板.xlsx';
              _context4.n = 3;
              break;
            case 1:
              if (!(type === 'performance')) {
                _context4.n = 2;
                break;
              }
              url = '/api/salaryController/downloadPerformanceTemplate';
              fileName = '奖励性绩效明细表模板.xlsx';
              _context4.n = 3;
              break;
            case 2:
              return _context4.a(2);
            case 3:
              _context4.p = 3;
              _context4.n = 4;
              return fetch(url, {
                method: 'GET',
                headers: {
                  'Authorization': localStorage.getItem('token') || sessionStorage.getItem('token') || ''
                }
              });
            case 4:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 5;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 5:
              _context4.n = 6;
              return response.blob();
            case 6:
              blob = _context4.v;
              // 创建下载链接并触发下载
              downloadUrl = window.URL.createObjectURL(blob);
              link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              // 释放创建的URL对象
              window.URL.revokeObjectURL(downloadUrl);
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t2 = _context4.v;
              _this2.$message.error('下载模板失败，请重试');
            case 8:
              return _context4.a(2);
          }
        }, _callee4, null, [[3, 7]]);
      }))();
    },
    // 下载反馈文件
    downloadFeedbackFile: function downloadFeedbackFile(feedbackData) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var response, blob, downloadUrl, link, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return fetch('/api/salaryController/downloadFeedbackFile', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('token') || sessionStorage.getItem('token') || ''
                },
                body: JSON.stringify({
                  feedbackData: feedbackData
                })
              });
            case 1:
              response = _context5.v;
              if (response.ok) {
                _context5.n = 2;
                break;
              }
              throw new Error("\u4E0B\u8F7D\u53CD\u9988\u6587\u4EF6\u5931\u8D25: ".concat(response.status));
            case 2:
              _context5.n = 3;
              return response.blob();
            case 3:
              blob = _context5.v;
              // 创建下载链接并触发下载
              downloadUrl = window.URL.createObjectURL(blob);
              link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', '身份证验证反馈文件.xlsx');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              // 释放创建的URL对象
              window.URL.revokeObjectURL(downloadUrl);
              _this3.$message.success('反馈文件下载成功');
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t3 = _context5.v;
              _this3.$message.error('下载反馈文件失败，请稍后重试');
            case 5:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 4]]);
      }))();
    }
  }
};